import { render, staticRenderFns } from "./editHandover.vue?vue&type=template&id=40472882&scoped=true"
import script from "./editHandover.vue?vue&type=script&lang=js"
export * from "./editHandover.vue?vue&type=script&lang=js"
import style0 from "./editHandover.vue?vue&type=style&index=0&id=40472882&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40472882",
  null
  
)

export default component.exports